const __RELATIVE_SOURCE_FILE__ /* __INJECTED__ */ = 'packages/patapp_web/src/components/eCheckin/hooks.ts';
import { getConfiguration } from 'App/utils/clientSetupGetRessource';
import { DEFAULT_ECHECKIN_WORKITEM_TKEY, useECheckinItem } from 'App/store/eCheckinItems';
import { KeyValuePair } from '@cistec/common_web/defs/generalDefs';
import _ from 'lodash';

export const useECheckinInitData = (fallNr?: string, tKey: string = DEFAULT_ECHECKIN_WORKITEM_TKEY) => {
    const { eCheckin: eCheckinConfig } = getConfiguration();

    const { data: workItem } = useECheckinItem(fallNr, tKey);
    // setting to undefined in case echeckin is set to empty string, which is done
    // when "resetting" eCheckin in KISIM
    const currentECheckinData = workItem?.CONTENT.echeckin || undefined;
    const eCheckinData: KeyValuePair = currentECheckinData ? _.cloneDeep(currentECheckinData) : {};
    const [initialValues, isLoading] = eCheckinConfig.initialValuesHook(fallNr);
    Object.keys(initialValues).forEach(key => {
        if (eCheckinData[key] === undefined) {
            eCheckinData[key] = initialValues[key];
        }
    });
    return [isLoading ? undefined : eCheckinData, isLoading];
};
